export default __webpack_public_path__ + "3c0cac12c8d68ccfbf3c5516c2d1ac7b.png";